import { types } from 'mobx-state-tree';

export default types.model('AddressSummary', {
  city: types.string,
  country: types.string,
  state: types.string,
  zip: types.string,
});
